<!-- Start: Rejwan: 19-06-2025 Reporting -->
<template>
    <div class="">
        <div class="clearfix company-form-container-warapper"> <!-- Mustafijur: 01-06-2026: Removed  company-form-container -->
            <div class="custom-loader-wrapper" v-if="loader">
                <div class="text-center">
                    <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                    <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                    <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>

                </div>
            </div>
            <!-- Mustafijur: 01-06-2026: Start: Commented -->
            <!-- <div class="company-form-container-title-wrapper">
                <div class="col-sm-12 px-3 company-form-box-title">
                    <div class="trustee-nav-first">
                        <div class="trustee-nav-head">Monhtly PF Settlement Report</div>
                        <div class="trustee-nav-subhead">Select parameters below to generate and download report.</div>
                    </div>
                </div>
            </div> -->
            <!-- Mustafijur: 01-06-2026: End: Commented -->

            <div class="report-button-contents">
                <!-- Start: Rejwan: 02-07-2025 Reporting -->
                <!-- <div class="row">
                    <div class="col-3">
                        <b-form-select class="" v-model="selected_year">
                            <b-form-select-option disabled value="">Please Select Year</b-form-select-option>
                            <b-form-select-option v-for="(year,index)  in years" :key="index"  :value="year">{{year}}</b-form-select-option>
                        </b-form-select>
                    </div>
                    <div class="col-3">
                        <b-form-select class="" v-model="selected_month">
                            <b-form-select-option disabled valu="">Please Select Month</b-form-select-option>
                            <b-form-select-option v-for="(label, value)  in months" :key="value"  :value="parseInt(value)">{{label}}</b-form-select-option>
                        </b-form-select>
                    </div>
                </div>

                <div class="button_wrapper">
                    <button v-on:click="getReport()" class="btn btn-primary position-static">Download</button>
                </div> -->

                <!-- Mustafijur: 01-06-2026: Start: Commented -->
                <!-- <div class="report-button-contents d-flex align-items-center">
                    <div class="title mr-2">From Month</div>
                    <div class="value mr-2">
                        <b-form-select v-model="start_month">
                            <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                        </b-form-select>
                    </div>

                    <div class="title mr-2">From Year</div>
                    <div class="value mr-2">
                        <b-form-select v-model="start_year">
                            <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                        </b-form-select>
                    </div>

                    <div class="title mr-2">To Month</div>
                    <div class="value mr-2">
                        <b-form-select v-model="end_month">
                            <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                        </b-form-select>
                    </div>

                    <div class="title mr-2">To Year</div>
                    <div class="value mr-2">
                        <b-form-select v-model="end_year">
                            <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                        </b-form-select>
                    </div>
                    <button v-on:click="getReportWithValidation()" class="btn btn-primary position-static ml-2">Download</button>
                </div> -->
                <!-- Mustafijur: 01-06-2026: End: Commented -->
                <!-- End: Rejwan: 02-07-2025 Reporting -->
            </div>

            <!-- Mustafijur: 01-06-2026: Start -->
            <div class="row mt-4 no-margin">
                <div class="ibox col-md-12">
                    <div class="ibox-title dashboard_title px-0">
                        <h4 class="font-regular with-blue-text">Current Selected: <span>Monhtly PF Settlement Report</span></h4>
                        <h4>Select parameters below to generate and download report.</h4>
                    </div>
                    <div class="ibox-content px-0 trz_ppl_wrapper_2">
                        <div class="report-button-contents d-flex align-items-center">
                            <div class="title mr-2">From Month</div>
                            <div class="value mr-2">
                                <b-form-select v-model="start_month">
                                    <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                                </b-form-select>
                            </div>

                            <div class="title mr-2">From Year</div>
                            <div class="value mr-2">
                                <b-form-select v-model="start_year">
                                    <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                                </b-form-select>
                            </div>

                            <div class="title mr-2">To Month</div>
                            <div class="value mr-2">
                                <b-form-select v-model="end_month">
                                    <b-form-select-option v-for="(month, n) in months" :key="n" :value="month.value">{{month.text}}</b-form-select-option>
                                </b-form-select>
                            </div>

                            <div class="title mr-2">To Year</div>
                            <div class="value mr-2">
                                <b-form-select v-model="end_year">
                                    <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                                </b-form-select>
                            </div>
                            <button v-on:click="getReportWithValidation()" class="btn btn-primary position-static ml-2">Download</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Mustafijur: 01-06-2026: Ends -->


        </div>
    </div>
</template>

<script>


    export default{

        mounted() {
        },
        props: [],
        components: {

        },
        data(){

            return {

                empty_result : 'Please hold tight! We are preparing the report data for you!',
                loader: false,
                showoverlay : true,
                years: [],
                // Start: Rejwan: 02-07-2025 Reporting
                // selected_year: null,
                // months: {
                //     1: "January",
                //     2: "February",
                //     3: "March",
                //     4: "April",
                //     5: "May",
                //     6: "June",
                //     7: "July",
                //     8: "August",
                //     9: "September",
                //     10: "October",
                //     11: "November",
                //     12: "December"
                // },
                // selected_month: null,
                months: [
                    { value: "1", text: "January" },
                    { value: "2", text: "February" },
                    { value: "3", text: "March" },
                    { value: "4", text: "April" },
                    { value: "5", text: "May" },
                    { value: "6", text: "June" },
                    { value: "7", text: "July" },
                    { value: "8", text: "August" },
                    { value: "9", text: "September" },
                    { value: "10", text: "October" },
                    { value: "11", text: "November" },
                    { value: "12", text: "December" },
                ],

                start_year : '',
                currentYear: new Date().getFullYear(),
                currentMonth:new Date().getMonth(),
                start_month: '',
                start_month_name: '',
                end_month: '',
                end_year: '',

                // End: Rejwan: 02-07-2025 Reporting
            };

        },
        methods:{
            // Start: Rejwan: 02-07-2025 Reporting
            validateDateRange() {
                const start = new Date(this.start_year, this.start_month - 1);
                const end = new Date(this.end_year, this.end_month - 1);

                if (start > end) {
                this.$bvToast.toast('Invalid range: Start month is after end month.', {
                            title: "Error",
                            variant: "danger",
                            solid: true,
                            });
                return false;
                }

                this.errorMessage = '';
                return true;
            },

            getReportWithValidation() {
                if (this.validateDateRange()) {
                this.getReport();  // Your actual report generation function
                }
            },
            // End: Rejwan: 02-07-2025 Reporting
            getReport: function()
            {
                if(!this.checkNet()) return false;
                this.loader = true;

                // Start: Rejwan: 02-07-2025 Reporting
                // if(this.selected_year == null || this.selected_month == null) {
                //     this.$bvToast.toast('Year and Month is Required', {
                //         title: 'Error',
                //         variant: 'danger',
                //         solid: true
                //     });
                //     this.loader = false;
                //     return false;
                // }
                // End: Rejwan: 02-07-2025 Reporting
                let url = ''

                url = this.$api_url + '/pf/report/monthly-settlement-report';


                let formData = new FormData();
                // Start: Rejwan: 02-07-2025 Reporting
                formData.append('start_year', this.start_year);
                formData.append('start_month', this.start_month);
                formData.append('end_year', this.end_year);
                formData.append('end_month', this.end_month);

                // formData.append('selected_month', this.selected_month);
                // formData.append('selected_year', this.selected_year);
                // End: Rejwan: 02-07-2025 Reporting
                let currentObj = this;
                 this.downloadBlobResponse(
                    axios.post(url, formData, { responseType: 'blob' }),
                    'loader' // your loader key in this component
                );
                return false;
            },
        },
        created: function(){
            const startYear = 2010;
            const currentYear = new Date().getFullYear();
            for (let y = startYear; y <= currentYear; y++) {
                this.years.push(y);
            }

        },
        computed:
        {
            // Start: Rejwan: 02-07-2025 Reporting
            years () {
                const year = new Date().getFullYear();
                return Array.from({length: year - 2018}, (value, index) => year - index)
            },
            // End: Rejwan: 02-07-2025 Reporting
        }
    }
</script>

<!-- End: Rejwan: 19-06-2025 Reporting -->
